export default __webpack_public_path__ + "static/media/applications-image-08.54661bcc.jpg";